export function isZipCode(zipCode) {
  const er = /^(([0-9]{5}-[0-9]{3}))$/;
  if(er.test(zipCode)) {
    return true;
  }
  return false;
}
